import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { AuthProvider, AuthCallback } from "./context/AuthContext";
import Home from "./pages/Home";
import Results from "./pages/Results";
import Book from "./pages/Book";
import Confirmation from "./pages/Confirmation";
import Trips from "./pages/Trips";
import Pay from "./pages/Pay";
import Admin from "./pages/Admin";
import GroupBooking from "./pages/GroupBooking";
import ResetPassword from "./pages/ResetPassword";
import Holidays, { PackageDetail } from "./pages/Holidays";

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/flights" element={<Results />} />
      <Route path="/book/:offerId" element={<Book />} />
      <Route path="/booking/:bookingId" element={<Confirmation />} />
      <Route path="/trips" element={<Trips />} />
      <Route path="/pay/:bookingId" element={<Pay />} />
      <Route path="/admin" element={<Admin />} />
      <Route path="/group-booking" element={<GroupBooking />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route path="/holidays" element={<Holidays />} />
      <Route path="/holidays/:slug" element={<PackageDetail />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppRouter />
        <Toaster position="top-center" richColors />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
